import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import Storefront from '@mui/icons-material/Storefront';

import ShareResourceBanner from '~components/ShareResourceBanner/ShareResourceBanner';
import { ShareResourceBannerConfig } from '~components/ShareResourceBanner/shareResourceBannerTypes';
import { TREAD_DOCS_URL } from '~constants/consts';

import { VENDOR_GUIDE_LINK } from './vendorGuideShareLinks';

const VENDOR_GUIDE_SHARE_CONFIG: ShareResourceBannerConfig = {
  testIdPrefix: 'vendor-guide-share',
  Icon: Storefront,
  primaryLink: VENDOR_GUIDE_LINK,
  translationNamespace: 'administration.vendor_guide_share',
  steps: [
    {
      titleKey: 'administration.vendor_guide_share.steps.step_1_title',
      subtitleKey: 'administration.vendor_guide_share.steps.step_1_subtitle',
    },
    {
      titleKey: 'administration.vendor_guide_share.steps.step_2_title',
      subtitleKey: 'administration.vendor_guide_share.steps.step_2_subtitle',
    },
    {
      titleKey: 'administration.vendor_guide_share.steps.step_3_title',
      subtitleKey: 'administration.vendor_guide_share.steps.step_3_subtitle',
    },
  ],
  aside: {
    kind: 'guides',
    items: [
      {
        Icon: SchoolOutlined,
        titleKey: 'administration.vendor_guide_share.guides.guide_title',
        href: VENDOR_GUIDE_LINK,
      },
      {
        Icon: MenuBookOutlined,
        titleKey: 'administration.vendor_guide_share.guides.docs_title',
        href: TREAD_DOCS_URL,
      },
    ],
  },
};

const VendorGuideShareBanner = () => (
  <ShareResourceBanner config={VENDOR_GUIDE_SHARE_CONFIG} />
);

export default VendorGuideShareBanner;
